export const savingsOverviewNb = {
    savingsOverview: {
        savingsDistributionSummary: {
            ariaLabel: 'Oversikt over sparing',
            loadingLabel: 'Laster oversikt over sparing',
            totalLabel: 'Total sparing',
            savingsLabel: 'Sparekonto',
            fundsLabel: 'Fond',
            sharesLabel: 'Aksjer',
            errorHeading: 'Kunne ikke hente oversikt over sparing',
            errorText: 'Vi klarte ikke å hente sparebeløpet ditt. Prøv igjen senere.',
        },
        showing: 'Viser {} av {}',
        total: 'Totalt: {}',
    },
    savingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekonto',
        listLabel: 'Sparekontoer',
        loadingLabel: 'Laster sparekontoer',
        fetchError: 'Kunne ikke hente sparekontoer. Prøv igjen senere.',
        emptyStateTitle: 'Sparing på sparekonto',
        emptyStateDescription: 'Spar trygt på konto og ha pengene tilgjengelig når du trenger dem. Opprett en sparekonto på få minutter.',
        emptyStateCreateSavingsAccount: 'Opprett sparekonto',
        interestsLoadingLabel: 'Laster opptjente renter',
        interestsEarnedFirstPart: 'Visste du at du har opptjent ',
        interestsEarnedLastPart: ' i renter på kontoer? Rentene utbetales på slutten av året.',
        interestsEarnedLastPartPenni: ' i renter på kontoer? Rentene utbetales månedlig.',
    },
    savingsFunds: {
        fundTrackingLabel: 'Gå til fond: {}',
        heading: 'Fond',
        loadingLabel: 'Laster fond',
        fetchError: 'Kunne ikke hente fond. Prøv igjen senere.',
        seeAllFunds: 'Gå til fondsside',
        hasPendingOrder: 'Ordre på vei',
        noFunds: {
            title: 'Sparing i fond',
            descriptionLineOne: 'Har du et sparemål som ligger litt frem i tid?',
            descriptionLineTwo: 'Fond kan hjelpe sparepengene dine til å vokse over tid.',
            startFundSaving: 'Lær mer om fondssparing',
            fundGuide: 'Finn fond som passer for deg',
            savingsGrowthCalculator: 'Se hva sparingen din kan vokse til',
        },
    },
    authorizedSavingsAccounts: {
        accountTrackingLabel: 'Gå til sparekonto',
        heading: 'Sparekontoer du har tilgang til',
        loadingLabel: 'Laster delte sparekontoer',
        fetchError: 'Kunne ikke hente delte sparekontoer. Prøv igjen senere.',
    },
    authorizedFundAccounts: {
        accountTrackingLabel: 'Gå til fondskonto',
        heading: 'Fondskontoer du har tilgang til',
        loadingLabel: 'Laster aksjesparekontoer du har tilgang til',
        fetchError: 'Kunne ikke hente aksjesparekontoer du har tilgang til. Prøv igjen senere.',
    },
    savingsAgreementsAccounts: {
        seeExistingAgreements: 'Se spareavtaler sparekonto',
        startNewAgreement: 'Start spareavtale sparekonto',
        title: 'Fast overføring til konto',
        monthlyAmount: '{} per måned',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Fast sparing til sparekonto',
        startSavingDescription: 'Sett av et fast beløp hver måned, så slipper du å huske det selv.',
        loadingLabel: 'Laster faste overføringer til konto',
        fetchError: 'Kunne ikke hente faste overføringer til konto. Prøv igjen senere.',
    },
    savingsAgreementsFunds: {
        seeExistingAgreements: 'Se spareavtaler i fond',
        startNewAgreement: 'Start spareavtale i fond',
        title: 'Spareavtale i fond',
        monthlyAmount: '{} per måned',
        nextPaymentDate: 'Neste trekk den {}',
        startSavingTitle: 'Spareavtale i fond',
        startSavingDescription: 'Sett av et fast beløp hver måned, så slipper du å huske det selv.',
        loadingLabel: 'Laster spareavtaler i fond',
        fetchError: 'Kunne ikke hente spareavtaler i fond. Prøv igjen senere.',
    },
    savingsAgreementsMicrosaving: {
        seeExistingAgreements: 'Se mikrosparavtaler',
        startNewAgreement: 'Start mikrosparing',
        title: 'Mikrosparing',
        oneAgreement: 'Du har {} mikrosparavtale',
        multipleAgreements: 'Du har {} mikrosparavtaler',
        description: 'Se dine avtaler',
        loadingLabel: 'Laster mikrosparavtaler',
        fetchError: 'Kunne ikke hente mikrosparavtaler. Prøv igjen senere.',
        startTitle: 'Mikrosparing',
        startDescription: 'Spar automatisk hver gang du bruker kortet. Kom i gang med mikrosparing.',
    },
    savingsEncouragement: {
        loadingLabel: 'Laster sparetips',
        texts: {
            NO_SAVINGS_PRODUCTS: 'Kom i gang med sparing! Finn en spareform som passer dine behov.',
            ACCOUNT_NO_FUNDS: 'Skal du spare over lengre tid? Se om fond kan passe for deler av sparingen din.',
            ACCOUNT_FUNDS_NO_AGREEMENTS: 'Gjør sparingen enklere med en spareavtale. Velg et beløp som settes av automatisk hver måned.',
            ACCOUNT_FUNDS_AGREEMENTS: 'Bra jobbet - du sparer jevnt og trutt! Selv et lite beløp kan vokse seg stort over tid.',
        },
        actions: {
            FIND_SAVINGS_PRODUCT: 'Finn en spareform',
            VIEW_FUNDS: 'Se sparing i fond',
            START_SAVING_AGREEMENT: 'Start fast sparing',
            INCREASE_SAVINGS_AMOUNT: 'Øk sparebeløp',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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